import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Loader2, ArrowLeft, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("dderon@gmail.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen cw-ocean-gradient flex items-center justify-center p-5 relative overflow-hidden">
      <div className="absolute -top-20 -left-20 w-96 h-96 bg-cyan-400 rounded-full cw-blob" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-sky-500 rounded-full cw-blob" />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative w-full max-w-md"
      >
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2 text-sky-200 hover:text-white text-sm font-semibold mb-5"
          data-testid="admin-back-to-site"
        >
          <ArrowLeft className="w-4 h-4" /> Back to website
        </button>

        <div className="bg-white rounded-3xl p-8 shadow-2xl">
          <div className="flex items-center gap-3 mb-6">
            <img src="/brand/logo.png" alt="Cool Waves" className="w-14 h-14 rounded-2xl object-cover shadow" />
            <div>
              <h1 className="font-display text-xl font-extrabold text-slate-900">Cool Waves Admin</h1>
              <p className="text-xs text-slate-500">CRM & Logistics Portal</p>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                data-testid="admin-login-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-11 rounded-xl"
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="pw">Password</Label>
              <Input
                id="pw"
                type="password"
                data-testid="admin-login-passcode-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="h-11 rounded-xl"
              />
            </div>
            <Button
              type="submit"
              data-testid="admin-login-submit-button"
              disabled={loading}
              className="w-full h-12 rounded-xl font-bold bg-sky-600 hover:bg-sky-500 text-white"
            >
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><Lock className="w-4 h-4 mr-1.5" /> Sign In</>}
            </Button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};
